import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import { ServiceApi } from "../../../services/user/service_api.services";
import { handleNotify, TOASTER_TYPE, TOASTER_POSITION } from "../../common/notification/toaster_notify.component";
import { useSelector } from "react-redux";
import moment from "moment";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { CustomerService } from "../../../services/user/customer.services";
import DataTable from "react-data-table-component";
import ItemDetailsModal from "../../dashboard/service_component/itemdetailsmodel.component"
import DocumentDetailsModal from "./documentmodel.component";
import { StateService } from "../../../services/user/state.services";
import { CountryService } from "../../../services/user/country.services";
import Select from 'react-select';
import striptags from "striptags";
import { getDateFormat, parseCultureDate } from "../../../utility";


const AddServicesComponent = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const serviceId = location.state?.serviceId || 0;
    const isEditMode = !!serviceId;
    const selectedStore = useSelector((state) => state?.user?.selectedStoreId);
    const [loading, setLoading] = useState(false);
    const [countries, setCountries] = useState([]);
    const [states, setStates] = useState([]);
    const [customer, setCustomer] = useState([]);
    const [showItemModal, setShowItemModal] = useState(false);
    const [showDocumentModal, setShowDocumentModal] = useState(false);

    // Static data for Items
    const staticItemsData = [
        {
            itemtype: "Electronics",
            mainItemName: "Laptop",
            itemName: "Dell XPS 13",
            description: "13-inch, Intel Core i7",
            itemSerialNo: "SN123456",
            purchaseDateMfg: "2022-05-01",
            warrantyMonthsMfg: 24,
            warrantyDateMfg: "2024-05-01",
            installationDate: "2022-06-15",
            warrantyMonthsCust: 18,

        },
        {
            itemtype: "Electronics",
            mainItemName: "Smartphone",
            itemName: "Samsung Galaxy S21",
            description: "128GB, 5G",
            itemSerialNo: "SN654321",
            purchaseDateMfg: "2021-12-01",
            warrantyMonthsMfg: 12,
            warrantyDateMfg: "2022-12-01",
            installationDate: "2021-12-15",
            warrantyMonthsCust: 12,
        },
    ];
    // Static data for Documents
    const staticDocumentsData = [
        {
            preview: "https://via.placeholder.com/40",
            itemName: "Laptop",
            documentType: "Invoice",
            description: "Invoice for Dell XPS 13",
        },
        {
            preview: "https://via.placeholder.com/40",
            itemName: "Smartphone",
            documentType: "Warranty",
            description: "Warranty for Samsung Galaxy S21",
        },
    ];
    const columnsItem = [
        { name: 'Item Type', selector: row => row.itemtype },
        { name: 'Main Item Name', selector: row => row.mainItemName },
        { name: 'Item Name', selector: row => row.itemName },
        { name: 'Description', selector: row => row.description },
        { name: 'Serial No', selector: row => row.itemSerialNo },
        { name: 'Purchase Date', selector: row => row.purchaseDateMfg },
        { name: 'Warranty Date', selector: row => row.warrantyDateMfg },
        {
            name: "Actions",
            button: true,
            width: "10%",
            cell: (row) => (
                <div className="d-flex justify-content-center gap-2">
                    <button className="btn btn-primary"
                    // onClick={() => handleEditClick(row)}
                    >
                        Edit
                    </button>
                    <button className="btn btn-danger"
                    // onClick={() => handleDeleteClick(row)}
                    >
                        Delete
                    </button>
                </div>
            ),
        },
    ];

    const columnsDocuments = [
        { name: 'Item Name', selector: row => row.itemName },
        { name: 'Document Type', selector: row => row.documentType },
        { name: 'Description', selector: row => row.description },
        { name: 'Preview', cell: row => <img src={row.preview} alt={row.itemName} /> },
        {
            name: "Actions",
            button: true,
            width: "10%",
            cell: (row) => (
                <div className="d-flex justify-content-center gap-2">
                    <button className="btn btn-primary"
                    // onClick={() => handleEditClick(row)}
                    >
                        Edit
                    </button>
                    <button className="btn btn-danger"
                    // onClick={() => handleDeleteClick(row)}
                    >
                        Delete
                    </button>
                </div>
            ),
        },
    ];

    const handleAddDocClick = () => {
        setShowDocumentModal(true);
    };
    const handleAddItemClick = () => {
        setShowItemModal(true);
    };
    const handleAddItem = (newItemDetails) => {
        console.log("New Item Details:", newItemDetails);
    };
    const handleAddDocument = (newDocumentDetails) => {
        console.log("New Document Details:", newDocumentDetails);
    };


    const formik = useFormik({
        initialValues: {
            customerId: 0,
            isEndCustomer: true,
            warrantyNo: "",
            InvoiceNo: "",
            InvoiceDate: new Date(),
            addressLine1: "",
            city: "",
            stateId: 0,
            pinCode: 0,
            countryId: 0,
            endCustomer: "",
            storeId: selectedStore,
        },
        validationSchema: Yup.object({
            warrantyNo: Yup.string().required("Please enter a valid warranty number"),
            InvoiceNo: Yup.string().required("Please enter a valid invoice number"),
            InvoiceDate: Yup.string().required("Please enter a valid invoice Date"),
        }),
        onSubmit: async (values) => {
            try {
                setLoading(true);
                const data = {
                    ...values,
                    InvoiceDate: values.InvoiceDate ? new Date(values.InvoiceDate).toISOString() : null,
                    customerId: Number(values.customerId),
                    countryId: Number(values.countryId),
                    stateId: Number(values.stateId),
                    pinCode: Number(values.pinCode),
                };
                if (isEditMode) {
                    await ServiceApi.updateServiceById(serviceId, data)
                        .then((response) => {
                            if (response) {
                                navigate("/service");
                            }
                        });
                } else {
                    await ServiceApi.addNewService(data)
                        .then((response) => {
                            if (response) {
                                navigate("/service");
                            }
                        });
                }
            } catch (error) {
                console.error("Error while submitting form:", error);
                handleNotify(
                    "An error occurred while saving the service.",
                    TOASTER_TYPE.ERROR,
                    TOASTER_POSITION.TOP_RIGHT
                );
            } finally {
                setLoading(false);
            }
        },
    });

    useEffect(() => {
        if (isEditMode) {
            const fetchServiceDetail = async () => {
                try {
                    const data = await ServiceApi.getServiceById(serviceId);
                    formik.setValues({
                        customerId: data?.customer?.customerId,
                        isEndCustomer: data?.isEndCustomer ?? true,
                        warrantyNo: data?.warrantyNo,
                        InvoiceNo: data?.InvoiceNo,
                        InvoiceDate: parseCultureDate(data?.InvoiceDate),
                        //InvoiceDate: moment(data?.InvoiceDate).format('YYYY-MM-DD'),
                        addressLine1: data?.address?.addressLine1,
                        city: data?.address?.city,
                        stateId: data?.address?.stateId,
                        pinCode: data?.address?.pinCode,
                        countryId: data?.address?.countryId,
                        endCustomer: data?.endCustomer,
                    });
                } catch (error) {
                    console.log("Error fetching service details", error);
                }
            };
            fetchServiceDetail();
        }
    }, []);

    // Formatting date to match format
    const handleDateChange = (val) => {
        const formattedDate = moment(val).toISOString();
        formik.setFieldValue("InvoiceDate", formattedDate);
    };

    const handleBackClick = () => {
        navigate("/service");
    };

    const fetchStates = async () => {
        try {
            const response = await StateService.getAllStates(selectedStore);
            if (response) {
                const sortedState = response.sort((a, b) => a.stateId - b.stateId);
                const stateOptions = sortedState.map(state => ({
                    value: state.stateId,
                    label: state.stateName,
                }));
                if (!formik.values.stateId && stateOptions.length > 0) {
                    formik.setFieldValue("stateId", stateOptions[0].value);
                }
                setStates(stateOptions);
            }
            else {
                setStates([]);
            }
        } catch (error) {
            console.error("Error fetching states:", error);
        }
    };

    const fetchCountry = async () => {
        try {
            const response = await CountryService.getAllCountry(selectedStore);
            if (response) {
                const sortedCountry = response.sort((a, b) => a.countryId - b.countryId);
                const countryIdOptions = sortedCountry.map(country => ({
                    value: country.countryId,
                    label: country.countryName,
                }));
                if (!formik.values.countryId && countryIdOptions.length > 0) {
                    formik.setFieldValue("countryId", countryIdOptions[0].value);
                }
                setCountries(countryIdOptions);
            }
            else {
                setCountries([]);
            }
        } catch (error) {
            console.error("Error fetching countries:", error);
        }
    };
    const fetchCustomer = async () => {
        try {
            const response = await CustomerService.getAllCustomers(selectedStore);
            if (response) {
                const sortedCustomer = response.sort((a, b) => a.customerId - b.customerId);
                const customerIdOptions = sortedCustomer.map(customer => ({
                    value: customer.customerId,
                    label: customer.companyName
                }));
                if (!formik.values.customerId && customerIdOptions.length > 0) {
                    formik.setFieldValue("customerId", customerIdOptions[0].value);
                }
                setCustomer(customerIdOptions);
            }
            else {
                setCustomer([]);
            }
        } catch (error) {
            console.error("Error fetching Customer:", error);
        }
    };

    useEffect(() => {
        fetchStates();
        fetchCountry();
        fetchCustomer();
    }, [selectedStore]);
    return (
        <div className="page-wrapper m-0">
            <div className="page-content">
                <div className="page-breadcrumb d-flex align-items-center mb-3">
                    <div
                        className="breadcrumb-title pe-3 text-primary fw-bold fs-4 cursor-pointer"
                        onClick={handleBackClick}
                    >
                        Services</div>
                    <div className="ps-3">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb mb-0 p-0">
                                <li className="breadcrumb-item active" aria-current="page">
                                    {isEditMode ? "Edit Service" : "New Service"}
                                </li>
                            </ol>
                        </nav>
                    </div>
                    <div className="ms-auto">
                        <button
                            type="button"
                            className="btn btn-outline-secondary me-2 px-4 py-2 rounded-3 shadow-sm hover-effect"
                            onClick={handleBackClick}
                        >
                            Back
                        </button>
                    </div>
                </div>
                <div className="card radius-10 border-top border-0 border-4 border-primary p-4">
                    <div className="card-body form-container">
                        <form onSubmit={formik.handleSubmit} className="mt-4">
                            <div className="row mb-4">
                                <div className="col-md-3 col-12">
                                    <label htmlFor="InvoiceDate" className="form-label d-flex">
                                        Customer Invoice Date<span className="text-danger">*</span>:
                                    </label>
                                    <div className="d-flex">
                                                                              <DatePicker
                                            selected={parseCultureDate(formik.values.InvoiceDate)}
                                            onChange={(date) => formik.setFieldValue("InvoiceDate", date)}
                                            onBlur={formik.handleBlur}
                                            name="InvoiceDate"
                                            dateFormat={getDateFormat()}
                                            className={`form-control ${formik.touched.InvoiceDate && formik.errors.InvoiceDate ? 'is-invalid' : ''}`}
                                            id="InvoiceDate"
                                        />
                                        {formik.touched.InvoiceDate && formik.errors.InvoiceDate && (
                                            <div className="text-danger">{formik.errors.InvoiceDate}</div>
                                        )}
                                    </div>
                                </div>
                                <div className="col-md-3 col-12 d-flex align-items-center justify-content-start mt-4 ps-5">
                                    <label className="form-label me-3">End Customer?</label>
                                    <div className="form-check form-check-inline me-3">
                                        <input
                                            type="radio"
                                            id="isEndCustomer"
                                            name="isEndCustomer"
                                            className="form-check-input"
                                            value={true}
                                            checked={formik.values.isEndCustomer === true}
                                            onChange={() => formik.setFieldValue("isEndCustomer", true)}
                                        />
                                        <label className="form-check-label" htmlFor="isEndCustomer">
                                            Yes
                                        </label>
                                    </div>
                                    <div className="form-check form-check-inline">
                                        <input
                                            type="radio"
                                            id="isNotEndCustomer"
                                            name="isEndCustomer"
                                            className="form-check-input"
                                            value={false}
                                            checked={formik.values.isEndCustomer === false}
                                            onChange={() => formik.setFieldValue("isEndCustomer", false)}
                                        />
                                        <label className="form-check-label" htmlFor="isNotEndCustomer">
                                            No
                                        </label>
                                    </div>
                                </div>

                                <div className="col-md-6 col-12">
                                    <label htmlFor="customerId" className="form-label d-flex">
                                        Customer:
                                    </label>
                                    <div className="text-start">
                                        <Select
                                            id="customerId"
                                            name="customerId"
                                            options={customer}
                                            value={customer.find(option => option.values === formik.values.customerId)}
                                            onChange={(selectedOption) => formik.setFieldValue('customerId', selectedOption.value)}
                                            menuPortalTarget={document.body}
                                        />
                                    </div>
                                </div>
                            </div>

                            {/* Warranty Number Field */}
                            <div className="row mb-4">
                                <div className="col-md-6 col-12">
                                    <label htmlFor="warrantyNo" className="form-label d-flex">
                                        Warranty No <span className="text-danger">*</span>:
                                    </label>
                                    <input
                                        type="text"
                                        id="warrantyNo"
                                        name="warrantyNo"
                                        className={`form-control ${formik.touched.warrantyNo && formik.errors.warrantyNo ? "is-invalid" : ""}`}
                                        placeholder="Enter Warranty Number"
                                        value={formik.values.warrantyNo}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                    />
                                    {formik.touched.warrantyNo && formik.errors.warrantyNo && (
                                        <div className="invalid-feedback d-flex">{formik.errors.warrantyNo}</div>
                                    )}
                                </div>

                                <div className="col-md-6 col-12">
                                    <label htmlFor="InvoiceNo" className="form-label d-flex">
                                        Invoice No <span className="text-danger">*</span>:
                                    </label>
                                    <input
                                        type="text"
                                        id="InvoiceNo"
                                        name="InvoiceNo"
                                        className={`form-control ${formik.touched.InvoiceNo && formik.errors.InvoiceNo ? "is-invalid" : ""}`}
                                        placeholder="Enter Invoice Number"
                                        value={formik.values.InvoiceNo}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                    />
                                    {formik.touched.InvoiceNo && formik.errors.InvoiceNo && (
                                        <div className="invalid-feedback d-flex">{formik.errors.InvoiceNo}</div>
                                    )}
                                </div>
                            </div>
                            {!formik.values.isEndCustomer && (
                                <div className="row mb-4">
                                    <div className="col-md-6 col-12">
                                        <label className="form-label d-flex">End Customer:</label>
                                        <input
                                            type="text"
                                            id="endCustomer"
                                            name="endCustomer"
                                            className={`form-control ${formik.touched.endCustomer && formik.errors.endCustomer ? "is-invalid" : ""}`}
                                            placeholder="Enter EndCustomer"
                                            value={formik.values.endCustomer}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                        />
                                        {formik.touched.endCustomer && formik.errors.endCustomer && (
                                            <div className="invalid-feedback">{formik.errors.endCustomer}</div>
                                        )}
                                    </div>
                                    {/* State Input Field */}
                                    <div className="col-md-6 col-12">
                                        <label htmlFor="state" className="form-label d-flex">
                                            State:
                                        </label>
                                        <div className="text-start">
                                            <Select
                                                id="stateId"
                                                name="stateId"
                                                options={states}
                                                value={states.find(option => option.value === formik.values.stateId)}
                                                onChange={(selectedOption) => formik.setFieldValue('stateId', selectedOption.value)}
                                                menuPortalTarget={document.body}
                                            />
                                        </div>
                                        {formik.touched.stateId && formik.errors.stateId && (
                                            <div className="invalid-feedback">{formik.errors.stateId}</div>
                                        )}
                                    </div>
                                </div>
                            )}

                            {!formik.values.isEndCustomer && (
                                <div className="row mb-4">
                                    <div className="col-md-6 col-12">
                                        <label htmlFor="addressLine1" className="form-label d-flex">Address:</label>
                                        <input
                                            type="text"
                                            id="addressLine1"
                                            name="addressLine1"
                                            className={`form-control ${formik.touched.addressLine1 && formik.errors.addressLine1 ? 'is-invalid' : ''}`}
                                            placeholder="Enter Address"
                                            value={formik.values.addressLine1}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                        />
                                        {formik.touched.addressLine1 && formik.errors.addressLine1 && (
                                            <div className="invalid-feedback">{formik.errors.addressLine1}</div>
                                        )}
                                    </div>
                                    <div className="col-md-6 col-12">
                                        <label htmlFor="country" className="form-label d-flex">Country:</label>
                                        <div className="text-start">
                                            <Select
                                                id="countryId"
                                                name="countryId"
                                                options={countries}
                                                value={countries.find(option => option.value === formik.values.countryId)}
                                                onChange={(selectedOption) => formik.setFieldValue('countryId', selectedOption.value)}
                                                menuPortalTarget={document.body}
                                            />
                                        </div>
                                        {formik.touched.countryId && formik.errors.countryId && (
                                            <div className="invalid-feedback">{formik.errors.countryId}</div>
                                        )}
                                    </div>
                                </div>
                            )}
                            {!formik.values.isEndCustomer && (
                                <div className="row mb-4">
                                    <div className="col-md-6 col-12">
                                        <label htmlFor="city" className="form-label d-flex">
                                            City:
                                        </label>
                                        <input
                                            type="text"
                                            id="city"
                                            name="city"
                                            className={`form-control ${formik.touched.city && formik.errors.city ? 'is-invalid' : ''}`}
                                            placeholder="Enter City"
                                            value={formik.values.city}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                        />
                                        {formik.touched.city && formik.errors.city && (
                                            <div className="invalid-feedback">{formik.errors.city}</div>
                                        )}
                                    </div>
                                    <div className="col-md-6 col-12">
                                        <label htmlFor="pinCode" className="form-label d-flex">pinCode:</label>
                                        <input
                                            type="text"
                                            id="pinCode"
                                            name="pinCode"
                                            className={`form-control ${formik.touched.pinCode && formik.errors.pinCode ? 'is-invalid' : ''}`}
                                            placeholder="Enter pinCode"
                                            value={formik.values.pinCode}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                        />
                                        {formik.touched.pinCode && formik.errors.pinCode && (
                                            <div className="invalid-feedback">{formik.errors.pinCode}</div>
                                        )}
                                    </div>
                                </div>
                            )}
                            {/* Submit */}
                            <hr />
                            <div className="d-flex flex-column flex-md-row mt-4 justify-content-end">
                                <button
                                    type="button"
                                    className="btn btn-outline-secondary mb-2 mb-md-0 me-2 px-4 py-2 rounded-3 shadow-sm hover-effect"
                                    onClick={handleBackClick}
                                >
                                    Back
                                </button>
                                <button
                                    type="submit"
                                    className="btn btn-primary px-4 py-2 rounded-3 shadow-sm hover-effect"
                                    disabled={loading}
                                >
                                    {loading ? "Saving..." : isEditMode ? "Update" : "Save"}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>

                {/* Items */}
                {isEditMode && (
                    <div className="card radius-10 border-top border-0 border-4 border-primary mt-4">
                        <div className="card-body form-container">
                            <div className="page-breadcrumb d-flex align-items-center mb-3">
                                <div className="breadcrumb-title pe-3 text-primary fw-bold fs-4">
                                    Items
                                </div>
                                <div className="ms-auto">
                                    <button className="btn btn-primary" onClick={handleAddItemClick}>
                                        New +
                                    </button>
                                </div>
                            </div>
                            <DataTable
                                columns={columnsItem}
                                data={staticItemsData}
                                pagination
                            />
                        </div>
                        <ItemDetailsModal
                            showModal={showItemModal}
                            setShowModal={setShowItemModal}
                            handleAddItem={handleAddItem}
                        />
                    </div>
                )}

                {/* Documents */}
                {isEditMode && (
                    <div className="card radius-10 border-top border-0 border-4 border-primary mt-4">
                        <div className="card-body form-container">
                            <div className="page-breadcrumb d-flex align-items-center mb-3">
                                <div className="breadcrumb-title pe-3 text-primary fw-bold fs-4">
                                    Documents
                                </div>
                                <div className="ms-auto">
                                    <button className="btn btn-primary" onClick={handleAddDocClick}>
                                        New +
                                    </button>
                                </div>
                            </div>
                            <DataTable
                                columns={columnsDocuments}
                                data={staticDocumentsData}
                                pagination
                            />
                        </div>
                        <DocumentDetailsModal
                            showModal={showDocumentModal}
                            setShowModal={setShowDocumentModal}
                            handleAddDocument={handleAddDocument}
                        />
                    </div>
                )}
            </div>
        </div>
    );
};
export default AddServicesComponent;
